import AddIcon from '@mui/icons-material/Add';
import CreateIcon from '@mui/icons-material/Create';
import { useMediaQuery } from '@mui/material';
import Box from 'component/layoutComponents/Box/Box';
import { MarketplaceThemeProvider } from 'component/theme/MarketplaceTheme';
import DefaultUptimeTheme from 'component/theme/defaultTheme';
import React, { Fragment, useMemo, useState } from 'react';
import { useTheme } from 'styled-components';
import AddressDialog from '../AddressDialog';
import Typography from '../Typography/Typography';
import { StyledDetailAddress } from './OrderRequest.style';
import Section from './Section';
import { Address, AddressConfig } from '../AddressDialog/types';

export interface IOrderRequestProps {
  addressItem?: Address;
  addressConfig?: AddressConfig;
  onSubmit?: (address: Address) => void;
  locale?: Record<string, any>;
  disabled?: boolean;
}

const DisplayAddress = (props: IOrderRequestProps) => {
  const { addressConfig, addressItem, onSubmit, locale, disabled } = props;

  const [openDialog, setOpenDialog] = useState(false);

  const theme = useTheme() as typeof DefaultUptimeTheme;
  const smUp = useMediaQuery(`(min-width:${theme.breakpoints.sm})`);

  const actionIcon = useMemo(() => {
    const Icon = addressItem ? CreateIcon : AddIcon;
    return <Icon onClick={() => setOpenDialog(true)} />;
  }, [addressItem]);

  return (
    <MarketplaceThemeProvider>
      <Section variant="h6" title={locale?.shoppingCart?.shippingTo} actionIcon={actionIcon} disabled={disabled}>
        {addressItem ? (
          addressConfig?.config.map(({ field }) => (
            <Fragment key={field}>
              {field === 'phoneNumber' && (
                <StyledDetailAddress variant={smUp ? 'body1' : 'body2'}>
                  {addressConfig.country.id}
                </StyledDetailAddress>
              )}
              <StyledDetailAddress variant={smUp ? 'body1' : 'body2'}>
                {addressItem[field]}
              </StyledDetailAddress>
            </Fragment>
          ))
        ) : (
          <Box className="content-box bodyRegular">
            <Typography color={theme.uptimeColors.textColors.secondary}>
              {locale?.shoppingCart?.noAddressSet}
            </Typography>
          </Box>
        )}
      </Section>

      <AddressDialog
        open={openDialog}
        addressConfig={addressConfig}
        initAddress={addressItem}
        onClose={() => setOpenDialog(false)}
        onSubmit={onSubmit}
        locale={locale}
      />
    </MarketplaceThemeProvider>
  );
};

export default DisplayAddress;
